import React, { useState, useEffect } from "react";
import { MDBDataTable } from "mdbreact";
import {
  MDBPagination,
  MDBPaginationItem,
  MDBPaginationLink
} from 'mdb-react-ui-kit';
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { get } from "../../Services/RestAPIService";
import { Link, useNavigate } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import Dummy from "../../assets/images/No_Image_Available.jpg"

const DatatableTables = ({ t }) => {

  const navigate = useNavigate();
  const [data, setData] = useState({
    columns: [
      {
        label: t("ID"),
        field: "id",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Name"),
        field: "name",
        sort: "asc",
        width: 150,
      },
      {
        label: t("Status"),
        field: "is_active",
        sort: "asc",
        width: 270,
      },
      {
        label: t("Image"),
        field: "image",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Parent Category"),
        field: "parent_category_name",
        sort: "asc",
        width: 150,
      },
      {
        label: t("Edit"),
        field: "edit",
        sort: "asc",
        width: 100,
      },
    ],
    rows: []
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);

  const getUsersData = async (page) => {
    try {
      const subcategoriesData = await get(`category/subcategories/?page=${page}&page_size=5`);
      setTotalPages(Math.ceil(subcategoriesData.length / 5)); // Adjust page size as needed

      // Mapping API response to fit the table rows
      const modifiedRows = subcategoriesData.map(subcategory => ({
        id: subcategory.id,
        name: subcategory.name,
        is_active: subcategory.is_active,
        image:  <img src={subcategory.image || Dummy} alt="User" width="50" height="50" />,
        parent_category_name: subcategory.parent_category ? subcategory.parent_category.name : "N/A",
        select: <input type="checkbox" checked={selectedRows.includes(subcategory.id)} onChange={() => handleCheckboxChange(subcategory.id)} />,
        edit: <Button color="secondary" onClick={() => handleEdit(subcategory.id)}>{t("Edit")}</Button>,
        subCategory: <Button color="primary" onClick={() => handleExercises(subcategory.id)}>{t("Pain Area Body Parts")}</Button>,
      }));

      // Updating the state with modified rows
      setData(prevState => ({
        ...prevState,
        rows: modifiedRows
      }));
    } catch (error) {
      console.error('Error fetching subcategory data:', error);
    }
  };

  useEffect(() => {
    getUsersData(currentPage);
  }, [currentPage]);

  const handleCheckboxChange = (id) => {
    const updatedSelectedRows = [...selectedRows];
    const index = updatedSelectedRows.indexOf(id);
    if (index === -1) {
      updatedSelectedRows.push(id);
    } else {
      updatedSelectedRows.splice(index, 1);
    }
    setSelectedRows(updatedSelectedRows);
  };

  const handleButtonClick = () => {
    const selectedIds = selectedRows;
    console.log("Selected IDs:", selectedIds);
  };

  const handleTableChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleEdit = (id) => {
    navigate(`/category/edit-sub-category/${id}`);
    console.log("Edit button clicked for subcategory with ID:", id);
  };

  const handleExercises = (id) => {
    navigate(`/category/sub-category/${id}`);
    console.log("View button clicked for subcategory with ID:", id);
  };

  return (
    <React.Fragment>
  <div className="page-content">
    <div className="container-fluid">
      <Breadcrumbs maintitle={t("Home")} title={t("Data")} breadcrumbItem={t("Pain Area's")} />
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <CardTitle className="h4 mb-0">{t("Pain Area's of body.")}</CardTitle>
                <Button color="primary" onClick={() => navigate(`/category/create-sub-category/id`)}>
                  <i className="typcn typcn-plus me-1"></i> {t("Add New Body Part")}
                </Button>
              </div>

              <MDBDataTable
                responsive
                striped
                bordered
                paging={false}
                data={{
                  columns: data.columns,
                  rows: data.rows
                }}
                className="custom-cursor-pointer"
              />

              <MDBPagination className='mt-3'>
                <MDBPaginationItem disabled={currentPage === 1}>
                  <MDBPaginationLink onClick={() => handleTableChange(currentPage - 1)} tabIndex="-1" aria-disabled={currentPage === 1}>
                    {t("Previous")}
                  </MDBPaginationLink>
                </MDBPaginationItem>
                {[...Array(totalPages).keys()].map(page => (
                  <MDBPaginationItem key={page + 1} active={currentPage === page + 1}>
                    <MDBPaginationLink onClick={() => handleTableChange(page + 1)}>
                      {page + 1}
                    </MDBPaginationLink>
                  </MDBPaginationItem>
                ))}
                <MDBPaginationItem disabled={currentPage === totalPages}>
                  <MDBPaginationLink onClick={() => handleTableChange(currentPage + 1)}>
                    {t("Next")}
                  </MDBPaginationLink>
                </MDBPaginationItem>
              </MDBPagination>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  </div>
</React.Fragment>
  );
};

export default withTranslation()(DatatableTables);
